import { Checkbox } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { personnelTranslationKeys } from '../../../../translations';
import { AvailabilityFormController } from '../../common.types';

type SendToDocplannerProps = {
   readonly register: AvailabilityFormController['register'];
   readonly trigger: AvailabilityFormController['trigger'];
};

export const SendToDocplanner = (props: SendToDocplannerProps): JSX.Element | null => {
   return protectFeature(
      'managingDocplannerSlots',
      <Checkbox
         testId={'sendToDocplanner'}
         controller={props.register('sendToDocplanner')}
         label={personnelTranslationKeys.sendToDocplanner}
         onSelectionChange={() => {
            props.trigger(['healthcareProviderLocation', 'slotDurationFixed']);
         }}
      />,
      null
   );
};
